import { PayloadData } from 'relay-runtime';

const getMutationResponse = (settingsData?: PayloadData) => {
    return {
        data: {
            updateSetting: {
                id: '7_setting',
                name: 'gant',
                is_locked: false,
                data: '{}',
                ...settingsData,
                __typename: 'Setting',
            },
        },
    };
};

const getQueryResponse = (settingsData?: PayloadData) => {
    return {
        data: {
            settings: {
                edges: [
                    {
                        cursor: 'Nw==',
                        node: {
                            id: '7_setting',
                            name: 'gant',
                            is_locked: false,
                            data: '{}',
                            ...settingsData,
                            __typename: 'Setting',
                        },
                    },
                ],
                structure: [
                    {
                        field: 'id',
                        type: 'String',
                        display: 'id',
                        type_decode: null,
                        editable: true,
                        nest: null,
                    },
                    {
                        field: 'name',
                        type: 'String!',
                        display: 'name',
                        type_decode: null,
                        editable: true,
                        nest: null,
                    },
                    {
                        field: 'is_locked',
                        type: 'Boolean',
                        display: 'is_locked',
                        type_decode: null,
                        editable: true,
                        nest: null,
                    },
                    {
                        field: 'data',
                        type: 'String',
                        display: 'data',
                        type_decode: null,
                        editable: true,
                        nest: null,
                    },
                ],
                pageInfo: {
                    count: 1,
                    endCursor: null,
                    hasNextPage: false,
                },
            },
        },
    };
};

export const getSettingsResponse = (operation: string, settingsData?: PayloadData) => {
    if (operation === 'query') {
        return getQueryResponse(settingsData);
    }

    return getMutationResponse(settingsData);
};
